(function($) {
	$.fn.blockedButton = function(options) {
		function checkIfAnyFieldHasChanged(fields) {
			var changed = false;

			fields.each(function() {
				if (this.type === 'checkbox') {
					changed = this.checked !== this.defaultChecked;
				} else {
					changed = this.value != this.defaultValue;
				}
				return !changed;
			});

			return changed;
		}

		return this.each(function() {
			var $button = $(this);

			$button.prop('disabled', true);

			options.fields.on('keyup change', function() {
				var fieldHasChanged = checkIfAnyFieldHasChanged(options.fields);
				var disabled = !fieldHasChanged;
				$button.prop('disabled', disabled);
			});
		});
	};
})(jQuery);
